import React, { useEffect, useState } from "react";
import "./Main.css";
import ESGImage from "../../assets/shutterstock_2484466337.webp";
import CarbonImage from "../../assets/shutterstock_2206317071.webp";
import CenImage from "../../assets/shutterstock_2436158035.webp";
import AiImage from "../../assets/shutterstock_2464233719.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import { useTranslation } from "react-i18next";
import "swiper/swiper-bundle.css";
function Main() {
  const { t } = useTranslation();
  const slides = [
    {
      image: ESGImage,
      title: "ESG Platform",
      sub1: "Platform",
      sub2: "Consult",
      description:"main_esg_four_card"
    },
    {
      image: CarbonImage,
      title: "Carbon Footprint Platform",
      sub1: "Platform",
      sub2: "Consult",
      description: "main_carbon_four_card"
    },
    {
      image: CenImage,
      title: "Centralized Platform",
      sub1: "Total IOT Solutions",
      sub2: "Total IT Solutions",
      description: "main_centralized_four_card"
    },
    {
      image: AiImage,
      title: "AI Platform",
      sub1: "Cost Optimized",
      sub2: "Machine Learning",
      description: "main_ai_four_card"
    },
  ];

  const [isMobile, setIsMobile] = useState(window.screen.width <= 932);

  useEffect(() => {
    // ฟังก์ชันตรวจสอบขนาดหน้าจอ
    const handleResize = () => {
      if (window.screen.width <= 932) {
        setIsMobile(true); // ถ้าเป็นมือถือหรือขนาดเล็ก
      } else {
        setIsMobile(false); // ถ้าเป็นขนาดใหญ่
      }
    };

    // เรียกใช้เมื่อแสดงผลครั้งแรกและเวลาเปลี่ยนขนาดหน้าจอ
    handleResize();
    window.addEventListener("resize", handleResize);

    // ลบ event listener เมื่อ component ถูก unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleReadMoreEsgClick = () => {
    const targetElement = document.getElementById("esg-content");
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleReadMoreFootprintClick = () => {
    const targetElement = document.getElementById("footprint-content");
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleReadMorecentralizedClick = () => {
    const targetElement = document.getElementById("centralized-content");
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleReadMoreAIClick = () => {
    const targetElement = document.getElementById("ai-content");
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      {!isMobile && (
        <div className="image-container">
          <div className="line-with-text">SUSTAIN-X</div>
          <div className="image-zoom">
            <div className="image-card">
              <img src={ESGImage} alt="Example" className="image" />
              <div className="image-content">
                <div style={{ marginBottom: "30px" }}>
                  <h3 className="text-card-page">ESG Platform</h3>
                </div>
                <div className="detail-content">
                  {t("main_esg_four_card")}
                </div>
                <div
                  onClick={handleReadMoreEsgClick}
                  className="read-more-btn-main"
                >
                  {t("read_more")}
                  <span className="hide-icon">
                    <i className="fa fa-chevron-down fa-icon"></i>
                  </span>
                </div>
              </div>
              {/* New text content added here */}
              <div className="center-text">
                <div className="center-text-head">ESG</div>
                <div className="center-text-sub">Platform</div>
                <div className="center-text-sub">Consult</div>
              </div>
            </div>

            <div className="image-card">
              <img src={CarbonImage} alt="Example" className="image" />
              <div className="image-content">
                <div style={{ marginBottom: "30px" }}>
                  <h3 className="text-card-page">Carbon Footprint Platform</h3>
                </div>
                <div className="detail-content">
                  {t("main_carbon_four_card")}
                </div>
                <div
                  onClick={handleReadMoreFootprintClick}
                  className="read-more-btn-main"
                >
                  {t("read_more")}
                  <span className="hide-icon">
                    <i className="fa fa-chevron-down fa-icon"></i>
                  </span>
                </div>
              </div>
              {/* New text content added here */}
              <div className="center-text">
                <div className="center-text-head">Carbon Footprint</div>
                <div className="center-text-sub">Platform</div>
                <div className="center-text-sub">Consult</div>
              </div>
            </div>

            <div className="image-card">
              <img src={CenImage} alt="Example" className="image" />
              <div className="image-content">
                <div style={{ marginBottom: "30px" }}>
                  <h3 className="text-card-page">Centralized Platform</h3>
                </div>
                <div className="detail-content">
                  {t("main_centralized_four_card")}
                </div>
                <div
                  onClick={handleReadMorecentralizedClick}
                  className="read-more-btn-main"
                >
                  {t("read_more")}
                  <span className="hide-icon">
                    <i className="fa fa-chevron-down fa-icon"></i>
                  </span>
                </div>
              </div>
              {/* New text content added here */}
              <div className="center-text">
                <div className="center-text-head">Centralized</div>
                <div className="center-text-sub">Total IOT Solutions</div>
                <div className="center-text-sub">Total IT Solutions</div>
              </div>
            </div>

            <div className="image-card">
              <img src={AiImage} alt="Example" className="image" />
              <div className="image-content">
                <div style={{ marginBottom: "30px" }}>
                  <h3 className="text-card-page">AI Platform</h3>
                </div>
                <div className="detail-content">
                  {t("main_ai_four_card")}
                </div>
                <div
                  onClick={handleReadMoreAIClick}
                  className="read-more-btn-main"
                >
                  {t("read_more")}
                  <span className="hide-icon">
                    <i className="fa fa-chevron-down fa-icon"></i>
                  </span>
                </div>
              </div>
              {/* New text content added here */}
              <div className="center-text">
                <div className="center-text-head">AI</div>
                <div className="center-text-sub">Cost Optimized</div>
                <div className="center-text-sub">Machine Learning</div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isMobile && (
        <div style={{ padding: "14px 18px" }}>
          <div className="mobile-line-with-text">SUSTAIN-X</div>
          <Swiper
            spaceBetween={16}
            slidesPerView={1}
            pagination={{ clickable: true }}
            navigation={{
              nextEl: null, // ใช้เฉพาะปุ่ม next
              prevEl: null, // ไม่ให้มีปุ่ม prev
            }}
            loop
          >
            {slides.map((slide, index) => (
              <SwiperSlide key={index}>
                <div
                  className="mobile-card-main-content"
                  style={{
                    backgroundImage: `url(${slide.image})`,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundBlendMode: "darken",
                    padding: "20px",
                    borderRadius: "10px",
                  }}
                >
                  <div className="mobile-card-top">
                    <div className="mobile-card-main-content-text-head">
                      {slide.title}
                    </div>
                    <div className="mobile-card-main-content-text-head-feature">
                      <div className="mobile-card-main-content-text-head-sub-feat">
                        {slide.sub1}
                      </div>
                      <div className="vertical-line"></div>{" "}
                      <div className="mobile-card-main-content-text-head-sub-feat">
                        {slide.sub2}
                      </div>
                    </div>
                  </div>
                  <div className="mobile-card-end">
                    <div className="mobile-card-main-content-text-sub">
                     {t(slides[index].description)}
                    </div>
                    <div className="dots">
                      {slides.map((_, dotIndex) => (
                        <span
                          key={dotIndex}
                          style={{
                            color: dotIndex === index ? "#00ab9d" : "#ccc", // สีเขียวสำหรับจุดปัจจุบัน
                            marginRight: "8px",
                            fontSize: "48px",
                          }}
                        >
                          .
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
    </>
  );
}

export default Main;
